import { createContext } from "react";
import { VirtualVisit, VirtualVisitRoom } from "./types";

export interface VirtualVisitContextProps {
    startVirtualVisit(customerUserId: number, locationId: number, contactId: number): Promise<VirtualVisit>
}

export const VirtualVisitContext = createContext<VirtualVisitContextProps>(null!)